var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Button from "@irati/ui/src/Button";
import AddOnePerson from "@irati-web/admin/src/containers/Users/AddOnePerson/AddOnePerson";
import AddMultiplePeople from "@irati-web/admin/src/containers/Users/AddMultiplePeople/AddMultiplePeople";
import { Para } from "@irati/ui/src/Labels";
import { H3 } from "@irati/ui/src/Headings";
import { FormattedMessage } from "@irati/utils/lang";
import Icon from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import { Card, RelativeContainer, IconWrapper } from "../styled";
var InviteFlow;
(function (InviteFlow) {
    InviteFlow["Manual"] = "Manual";
    InviteFlow["Csv"] = "Csv";
})(InviteFlow || (InviteFlow = {}));
var InvitePeople = /** @class */ (function (_super) {
    __extends(InvitePeople, _super);
    function InvitePeople() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleStartInvite = function (flow) {
            _this.setState({ inviting: flow });
        };
        return _this;
    }
    InvitePeople.prototype.render = function () {
        var _this = this;
        var inviting = this.state.inviting;
        var _a = this.props, onCallback = _a.onCallback, teams = _a.teams;
        if (inviting === InviteFlow.Manual) {
            return React.createElement(AddOnePerson, { gotoSuccess: onCallback, goBack: onCallback, teams: teams });
        }
        if (inviting === InviteFlow.Csv) {
            return React.createElement(AddMultiplePeople, { goBack: onCallback, gotoSuccess: onCallback, teams: teams });
        }
        return (React.createElement(RelativeContainer, null,
            React.createElement(Flex, { alignItems: "center" },
                React.createElement(IconWrapper, { onClick: this.props.onCallback },
                    React.createElement(Icon, { icon: "backArrow", size: 25 })),
                React.createElement(H3, null,
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.addPeopleOptions.title" }))),
            React.createElement(Para, { margin: "30px 0" },
                React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.addPeopleOptions.description" })),
            React.createElement(Flex, { justifyContent: "space-between" },
                React.createElement(Card, null,
                    React.createElement(Para, { center: true, margin: "0 0 30px" },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.addPeopleOptions.addManual.description" })),
                    React.createElement(Button, { primary: true, onClick: function () { return _this.handleStartInvite(InviteFlow.Manual); } },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.addPeopleOptions.addManual.cta" }))),
                React.createElement(Card, null,
                    React.createElement(Para, { center: true, margin: "0 0 30px" },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.addPeopleOptions.addCsv.description" })),
                    React.createElement(Button, { primary: true, onClick: function () { return _this.handleStartInvite(InviteFlow.Csv); } },
                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.invite.addPeopleOptions.addCsv.cta" }))))));
    };
    return InvitePeople;
}(Component));
export default InvitePeople;
